import { render } from "./chat-right-video.vue?vue&type=template&id=0bca5fd8"
import script from "./chat-right-video.vue?vue&type=script&lang=js"
export * from "./chat-right-video.vue?vue&type=script&lang=js"

import "./chat-right-video.vue?vue&type=style&index=0&id=0bca5fd8&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__